import { render, staticRenderFns } from "./HomeContentBlockFareScraper.vue?vue&type=template&id=b4baeafc&scoped=true"
import script from "./HomeContentBlockFareScraper.vue?vue&type=script&lang=js"
export * from "./HomeContentBlockFareScraper.vue?vue&type=script&lang=js"
import style0 from "./HomeContentBlockFareScraper.vue?vue&type=style&index=0&id=b4baeafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4baeafc",
  null
  
)

export default component.exports